import { PlatformPerfMetric } from '@tob/shared/monitoring/enums';
import { appTimingUtil, monitor } from '@tob/shared/monitoring/utils';

export const trackWebBridgeCall = ({ method }: { method: string }) => {
  const startTime = appTimingUtil.getAppAliveDuration();
  return {
    end: ({
      status = 'success',
      data,
    }: {
      status?: string;
      data?: Record<string, any>;
    } = {}) => {
      const duration = Math.max(
        0,
        appTimingUtil.getAppAliveDuration() - startTime
      );
      monitor.sendDuration({
        name: PlatformPerfMetric.WebBridgeCall,
        duration,
        data: {
          operation_name: method,
          status,
          ...data,
        },
      });
    },
  };
};
